// extracted by mini-css-extract-plugin
var _1 = "Badge-module__animateUploadProgressBarWidth--iIlyq";
var _2 = "Badge-module__animatedBackground--E0ff5";
var _3 = "Badge-module__badge--Y3gBz";
var _4 = "Badge-module__badgeButton--wpWfn";
var _5 = "Badge-module__blue--IE_us";
var _6 = "Badge-module__content--MhInn";
var _7 = "Badge-module__gray--hPrtP";
var _8 = "Badge-module__green--x_Uwi";
var _9 = "Badge-module__hasIcon--p12TY";
var _a = "Badge-module__icon--glWaI";
var _b = "Badge-module__inline--QWYv1";
var _c = "Badge-module__pink--tR8DP";
var _d = "Badge-module__red--g_D1a";
var _e = "Badge-module__yellow--Qq7ri";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "badgeButton", _5 as "blue", _6 as "content", _7 as "gray", _8 as "green", _9 as "hasIcon", _a as "icon", _b as "inline", _c as "pink", _d as "red", _e as "yellow" }
